export default __webpack_public_path__ + "static/media/table_cancer_PC_En.4aab95f6.webp";